export class SortDirections {
    static readonly ASC = 'asc';
    static readonly DESC = 'desc';
}
